module.exports = __webpack_public_path__ + "static/media/IMG_1464.32b92302.jpg";